import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('tz_user');
    return stored ? JSON.parse(stored) : null;
  });
  const [loading, setLoading] = useState(false);

  // The saved user can be out of date (for example an admin has just switched
  // Stock Take on or off), so refresh it from the server once when the app loads.
  useEffect(() => {
    if (!localStorage.getItem('tz_token')) return;
    api.get('/api/auth/me')
      .then(res => {
        if (!res.data?.id || !localStorage.getItem('tz_token')) return;
        localStorage.setItem('tz_user', JSON.stringify(res.data));
        setUser(res.data);
      })
      .catch(() => {}); // an expired login (401) is handled in api.js; otherwise keep the saved user
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/api/auth/login', { email, password });
    const { token, user } = res.data;
    localStorage.setItem('tz_token', token);
    localStorage.setItem('tz_user', JSON.stringify(user));
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem('tz_token');
    localStorage.removeItem('tz_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
